import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { ButtonAgGridComponent } from '../ag-component/button-renderermutibuttons.component';
import { CustomTooltipComponent } from '../ag-component/customtooltip.component';
import { AllModules, Module } from '@ag-grid-enterprise/all-modules';
import { AvatarFullComponent } from '../ag-component/avatarFull.component';
import { ActivatedRoute } from '@angular/router';
declare var window: any;
@Component({
  selector: 'app-list-grid-angular',
  templateUrl: './list-grid-angular.component.html',
  styleUrls: ['./list-grid-angular.component.css']
})
export class ListGridAngularComponent implements OnInit, OnChanges {
  public modules: Module[] = AllModules;
  @Input() overlayNoRowsTemplate = '';
  @Input() listsData: Array<any> = [];
  @Output() FnClick = new EventEmitter<any>();
  @Output() callback = new EventEmitter<any>();
  @Output() rowDoubleClicked = new EventEmitter<any>();
  @Output() rowClicked = new EventEmitter<any>();
  @Output() cellDoubleClicked = new EventEmitter<any>();
  @Output() onCellClicked = new EventEmitter<any>();
  @Input() columnDefs: Array<any> = [];
  @Input() rowSelection: string = 'single';
  @Input() frameworkComponents = {};
  @Input() pinnedTopRowData: any[] = [];
  @Input() detailCellRendererParams: any;
  @Input() rowClassRules: any;
  @Input() floatingFilter: boolean = true;
  @Input() buttons = [];
  @Input() title: string = '';
  // autoHeight
  @Input() domLayout: string = '';
  @Input() height: number = 630;
  @Input() headerHeight: number = 40;
  @Input() heightRow: number = 49;
  @Input() getContextMenuItems: any = null;
  @Input() excelStyles: any[] = [
    {
      id: 'stringType',
      dataType: 'string'
    },
    {
      id: 'dateType',
      dataType: 'dateTime'
    },
    {
      id: 'numberType',
      dataType: 'number'
    }
  ];
  isRowSelectable;
  defaultColDef;
  checkColumn: any;
  sideBar: any
  gridApi: any;
  colState: any;
  getRowHeight: any;
  gridColumnApi: any;
  groupDefaultExpanded = 0;
  heightAuto = 0;
  excelExportParams;
  csvExportParams;
  tooltipShowDelay = 0;
  isRowMaster
  constructor(
    private activeRouter: ActivatedRoute
  ) {
    this.isRowMaster = (dataItem) =>{
      return dataItem && dataItem.submenus ? dataItem.submenus.length > 0 : false;
    };
    this.defaultColDef = {
      tooltipComponent: 'customTooltip',
      resizable: true,
      suppressSizeToFit: false,
      filter: '',
      rowHeight: 90,
      cellClass: ['border-right'],
      tooltipComponentParams: { color: '#ececec' },
    };

    this.frameworkComponents = {
      customTooltip: CustomTooltipComponent,
      buttonAgGridComponent: ButtonAgGridComponent,
      avatarRendererFull: AvatarFullComponent
    };
    this.tooltipShowDelay = 0
    
    this.getRowHeight = (params: any) => {
     
      if (params.node.master ||  params.node.level === 0) {
        return this.heightRow
      }else {
        
      }
    };

    // this.sideBar = {
    //   toolPanels: [
    //     {
    //       id: 'columns',
    //       labelDefault: 'Tuỳ chỉnh cột',
    //       labelKey: 'columns',
    //       iconKey: 'columns',
    //       toolPanel: 'agColumnsToolPanel',
    //       toolPanelParams: {
    //         suppressRowGroups: true,
    //         suppressValues: true,
    //         suppressPivots: true,
    //         suppressPivotMode: true,
    //         suppressColumnFilter: true,
    //         suppressColumnSelectAll: true,
    //         suppressColumnExpandAll: true,
    //         suppressSyncLayoutWithGrid: true,
    //         suppressColumnMove: false,
    //       },
    //     },
    //   ],
    //   position: '',
    //   defaultToolPanel: '',
      
    // };
  }
  // this.gridColumnApi.setPivotMode(true);

  RowDoubleClicked(event) {
    this.rowDoubleClicked.emit(event);
  }

  RowClicked(event) {
    this.rowClicked.emit(event);
  }

  CellDoubleClicked(event) {
    this.cellDoubleClicked.emit(event);
  }

  isChange = false
  onCellValueChanged(event) {
    // console.log(event)
    // console.log(event.value != event.oldValue)
    if (event.value != event.oldValue) {
      this.isChange = true;
    } else {
      this.isChange = false;
    }
  }

  CellClicked(event) {
    this.onCellClicked.emit(event);
  }

  ngOnInit(): void { 
    var pivotModeOn = document.getElementById('myGrid');
    pivotModeOn?.addEventListener('change', (event: any) => {
   
      // console.log(this.gridApi.getSelectedRows())
      if (event.target.ariaLabel === 'Press SPACE to toggle visibility (visible)' || event.target.ariaLabel === 'Press SPACE to toggle visibility (hidden)') {
        let allColumnIds: any = [];
        this.gridColumnApi.getAllColumns()
          .forEach((column: any) => {
            if (column.colDef.cellClass.indexOf('no-auto') < 0) {
              allColumnIds.push(column)
            } else {
              column.colDef.resizable = false;
            }
          });
        this.gridColumnApi.autoSizeColumns(allColumnIds, false);
        this.autoSizeAll()
      }else if(event.target.ariaLabel === 'Press Space to toggle row selection (checked)'
                || event.target.ariaLabel === 'Press Space to toggle row selection (unchecked)'
                || event.target.ariaLabel === 'Press Space to toggle all rows selection (checked)'
                || event.target.ariaLabel === 'Press Space to toggle all rows selection (unchecked)') {
                  this.callback.emit(this.gridApi.getSelectedRows())
                }
    })
  }

  saveState() {
    window.colState = this.gridColumnApi.getColumnState();
    const convert = [{
       key: "tai-san",
       configColumn: window.colState
    }]
    const columnState = JSON.stringify(convert);
    localStorage.setItem('myColumnState', columnState);
  }

  getOpenedToolPanel() {
    // alert(this.gridApi.getOpenedToolPanel());
    this.checkColumn = this.gridApi.getOpenedToolPanel()
  }

  // restoreState() {
  //   if (!window.colState) {
  //     console.log('no columns state to restore by, you must save state first');
  //     return;
  //   }
  //   this.gridColumnApi.applyColumnState({
  //     state: window.colState,
  //     applyOrder: true,
  //   });
  //   console.log('column state restored');
  // }

  resetState() {
    // this.gridColumnApi.resetColumnState();
    // console.log('column state reset');
    this.autoSizeAll();
    localStorage.removeItem('myColumnState')
  }

  openToolPanel(key: string) {
    this.gridApi.openToolPanel(key);
  }

  closeToolPanel() {
    this.gridApi.closeToolPanel();
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    let allColumnIds: any = [];
    this.gridColumnApi.getAllColumns()
      .forEach((column: any) => {
        if (column.colDef.cellClass.indexOf('no-auto') < 0) {
          allColumnIds.push(column)
        } else {
          column.colDef.resizable = false;
        }
      });
    this.gridColumnApi.autoSizeColumns(allColumnIds, false);
    
    const columnState = JSON.parse(localStorage.getItem('myColumnState'));
    this.autoSizeAll();
    if (columnState && this.activeRouter.url['_value'][0].path === columnState[0].key ) {
      params.columnApi.setColumnState(columnState[0].configColumn);
      this.autoSizeAll();
    }
  }

  ngOnChanges() {
    // this.heightAuto = this.listsData.length > 0 ? 50 + (this.listsData.length === 1 ? 80 : 60 * this.listsData.length) : 100;
    this.heightAuto = this.height;
    // this.heightAuto = this.heightAuto < 660 ? this.heightAuto : 660
  }

  onRowSelected(event) {
    this.callback.emit(this.gridApi.getSelectedRows())
  }
  
  sizeToFit() {
    if (this.gridApi) {
      let allColumnIds: any = [];
      this.gridColumnApi.getAllColumns()
        .forEach((column: any) => {
          if (column.colDef.cellClass.indexOf('no-auto') < 0) {
            allColumnIds.push(column)
          } else {
            column.colDef.suppressSizeToFit = true;
            allColumnIds.push(column)
          }
        });
      this.gridApi.sizeColumnsToFit(allColumnIds);
    }
  }

  autoSizeAll() {
    if (this.gridColumnApi) {
      if (this.gridColumnApi.columnModel.bodyWidth + this.gridColumnApi.columnModel.rightWidth  < this.gridColumnApi.columnModel.scrollWidth) {
        this.sizeToFit();
      } else {
        let allColumnIds: any = [];
        this.gridColumnApi.getAllColumns()
          .forEach((column: any) => {
            if (column.colDef.cellClass.indexOf('no-auto') < 0) {
              allColumnIds.push(column)
            } else {
              column.colDef.resizable = false;
            }
          });
        this.gridColumnApi.autoSizeColumns(allColumnIds, false);
      }
    }
  }


  OnClick(event: any) {
    this.FnClick.emit(event);
  }

  create(label: any) {
    this.callback.emit(label);
  }

  handleScroll(event: any) {
      // if(this.gridColumnApi) {
      //   let allColumnIds: any = [];
      //   this.gridColumnApi.getAllColumns()
      //     .forEach((column: any) => {
      //       if (column.colDef.cellClass.indexOf('no-auto') < 0) {
      //         allColumnIds.push(column)
      //       } else {
      //         column.colDef.resizable = false;
      //       }
      //     });
      //   this.gridColumnApi.autoSizeColumns(allColumnIds, false);
      //   const grid = document.getElementById('myGrid');
      //   if (grid) {
      //     const gridBody = grid.querySelector('.ag-body-viewport') as any;
      //     this.autoSizeAll();
      //   }
      // }
  }

  getSelectedRow() {
    return this.gridApi.getSelectedRows();
  }

  getGridApi () {
    return this.gridApi;
  }
}
